<template>
  <BaseModal ref="modal" modal-classes="max-w-md mx-auto" @modal-after-leave="$emit('closed')">
    <template #header>
      <span class="block text-xs text-gray-700 uppercase tracking-wider">provider</span>
      <h3 class="text-2xl text-gray-900">New Provider</h3>
    </template>

    <template #default="modalProps">
      <FormServiceProvider
        :service-uuid="serviceUuid"
        :service-provider-uuid="serviceProviderUuid"
        @success="modalProps.close"
        @cancel="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import FormServiceProvider from './FormServiceProvider.vue';

export default {
  name: 'ModalCreateOrUpdate',
  components: {
    FormServiceProvider,
  },
  props: {
    serviceUuid: {
      type: String,
      required: true,
    },
    serviceProvider: {
      type: Object,
      default: null,
    },
  },
  computed: {
    serviceProviderUuid() {
      return this.serviceProvider ? this.serviceProvider.uuid : null;
    },
  },
};
</script>
